import { FC, useState } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { readHeld } from "../EmailCode/heldBooking";
import ReservedCodeGate from "./ReservedCodeGate";

/**
 * /reserved.
 *
 * 1NOW-10770: with no booking in the address but a reservation held for a returning renter's email code, the page is
 * the code box; the booking is made when the code is right (ReservedCodeGate). The hold is read once, so dropping it
 * on the way on does not send the renter off.
 *
 * 1NOW-11476 (Taha): "Your car is reserved" is gone. A reservation opens on its booking page, restricted until it is
 * paid, with Pay and book there; an older link to /reserved?id= goes there too.
 */
const ReservedPage: FC = () => {
  const [params] = useSearchParams();
  const id = params.get("id");
  const location = useLocation();
  const [held] = useState(() => (id ? null : readHeld()));
  if (!id && held) return <ReservedCodeGate held={held} />;
  return <Navigate replace to={id ? `/booking-details?id=${encodeURIComponent(id)}` : "/vehicles"} state={location.state} />;
};

export default ReservedPage;
